import { SVGProps } from "react";

export const SVGIconCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" fill="none" viewBox="0 0 10 12" {...props}>
    <path
      fill="#717171"
      d="M8.029 1.405h-.605v-.303a.303.303 0 00-.606 0v.303H3.187v-.303a.303.303 0 00-.606 0v.303h-.605A1.816 1.816 0 00.16 3.221v6.053a1.816 1.816 0 001.816 1.816H8.03a1.816 1.816 0 001.816-1.816V3.22a1.816 1.816 0 00-1.816-1.816zm1.21 7.869a1.212 1.212 0 01-1.21 1.21H1.976a1.212 1.212 0 01-1.21-1.21V4.432H9.24v4.842zm0-5.448H.766v-.605a1.212 1.212 0 011.211-1.21h.605v.302a.303.303 0 00.606 0V2.01h3.631v.303a.303.303 0 00.606 0V2.01h.605a1.212 1.212 0 011.21 1.211v.605zM3.276 7.975a.303.303 0 01.428-.428l.972.971 2.21-2.762a.303.303 0 01.472.378L4.937 9.16a.303.303 0 01-.22.113H4.7a.302.302 0 01-.214-.088l-1.21-1.21z"
    ></path>
  </svg>
);
